export const getLink = (str: string) => {
  if (!str || !str.startsWith('@') || str.length !== 5) return null
  return str.slice(1)
}